import React from "react";
import { TooltipRenderProps } from "react-joyride";
import { Box, Typography, Button, Paper } from "@mui/material";

const TourTooltip: React.FC<TooltipRenderProps> = ({
  index,
  step,
  backProps,
  primaryProps,
  skipProps,
  isLastStep,
}) => {
  return (
    <Paper
      elevation={8}
      sx={{
        width: 380,
        borderRadius: "16px",
        overflow: "hidden",
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 255, 255, 0.3)",
      }}
    >
      {/* Header with Close */}

      {/* Content */}
      <Box sx={{ p: 3, pt: 5 }}>
        {step.title && (
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Poppins",
              fontWeight: 700,
              fontSize: "18px",
              color: "#4D1277",
              mb: 1,
            }}
          >
            {step.title}
          </Typography>
        )}
        <Typography
          sx={{
            fontFamily: "Poppins",
            fontSize: "15px",
            lineHeight: "1.6",
            color: "#444",
            mb: 3,
          }}
        >
          {step.content}
        </Typography>

        {/* Footer Actions */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* Left Side: Skip or Back */}
          <Box>
            {!isLastStep && (
              <Button
                {...skipProps}
                sx={{
                  textTransform: "none",
                  color: "#777",
                  fontSize: "13px",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: "transparent",
                    color: "#4D1277",
                  },
                }}
              >
                Skip guide
              </Button>
            )}
            {index > 0 && (
              <Button
                {...backProps}
                sx={{
                  textTransform: "none",
                  color: "#4D1277",
                  fontSize: "13px",
                  fontWeight: 600,
                  ml: !isLastStep ? 1 : 0,
                }}
              >
                Back
              </Button>
            )}
          </Box>

          {/* Right Side: Next/Last */}
          <Button
            {...primaryProps}
            variant="contained"
            sx={{
              textTransform: "none",
              backgroundColor: "#4D1277",
              borderRadius: "10px",
              padding: "8px 24px",
              fontWeight: 700,
              fontSize: "14px",
              boxShadow: "0 4px 12px rgba(77, 18, 119, 0.2)",
              "&:hover": {
                backgroundColor: "#3a0d5a",
                boxShadow: "0 6px 16px rgba(77, 18, 119, 0.3)",
              },
            }}
          >
            {isLastStep ? "Finish" : "Next"}
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default TourTooltip;
